import { render, staticRenderFns } from "./arecieve.vue?vue&type=template&id=119783d2&scoped=true&"
import script from "./arecieve.vue?vue&type=script&lang=js&"
export * from "./arecieve.vue?vue&type=script&lang=js&"
import style0 from "./arecieve.vue?vue&type=style&index=0&id=119783d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119783d2",
  null
  
)

export default component.exports